function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "04_Icons/navigation/app_select_white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Line",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32,0 L32,32 L0,32 L0,0 L32,0 Z M31.25,0.75 L0.75,0.75 L0.75,31.25 L31.25,31.25 L31.25,0.75 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "16.875 4.625 16.875 27.375 16.125 27.375 16.125 4.625"
}), /*#__PURE__*/React.createElement("polygon", {
  transform: "translate(16.625000, 16.000000) rotate(-90.000000) translate(-16.625000, -16.000000) ",
  points: "16.875 4.625 16.875 27.375 16.125 27.375 16.125 4.625"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11,5 C12.1045695,5 13,5.8954305 13,7 L13,11 C13,12.1045695 12.1045695,13 11,13 L7,13 C5.8954305,13 5,12.1045695 5,11 L5,7 C5,5.8954305 5.8954305,5 7,5 L11,5 Z M11,5.75 L7,5.75 C6.35279131,5.75 5.8204661,6.24187466 5.75645361,6.87219476 L5.75,7 L5.75,11 C5.75,11.6472087 6.24187466,12.1795339 6.87219476,12.2435464 L7,12.25 L11,12.25 C11.6472087,12.25 12.1795339,11.7581253 12.2435464,11.1278052 L12.25,11 L12.25,7 C12.25,6.35279131 11.7581253,5.8204661 11.1278052,5.75645361 L11,5.75 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11,19 C12.1045695,19 13,19.8954305 13,21 L13,25 C13,26.1045695 12.1045695,27 11,27 L7,27 C5.8954305,27 5,26.1045695 5,25 L5,21 C5,19.8954305 5.8954305,19 7,19 L11,19 Z M11,19.75 L7,19.75 C6.35279131,19.75 5.8204661,20.2418747 5.75645361,20.8721948 L5.75,21 L5.75,25 C5.75,25.6472087 6.24187466,26.1795339 6.87219476,26.2435464 L7,26.25 L11,26.25 C11.6472087,26.25 12.1795339,25.7581253 12.2435464,25.1278052 L12.25,25 L12.25,21 C12.25,20.3527913 11.7581253,19.8204661 11.1278052,19.7564536 L11,19.75 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26,5 C27.1045695,5 28,5.8954305 28,7 L28,11 C28,12.1045695 27.1045695,13 26,13 L22,13 C20.8954305,13 20,12.1045695 20,11 L20,7 C20,5.8954305 20.8954305,5 22,5 L26,5 Z M26,5.75 L22,5.75 C21.3527913,5.75 20.8204661,6.24187466 20.7564536,6.87219476 L20.75,7 L20.75,11 C20.75,11.6472087 21.2418747,12.1795339 21.8721948,12.2435464 L22,12.25 L26,12.25 C26.6472087,12.25 27.1795339,11.7581253 27.2435464,11.1278052 L27.25,11 L27.25,7 C27.25,6.35279131 26.7581253,5.8204661 26.1278052,5.75645361 L26,5.75 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26,19 C27.1045695,19 28,19.8954305 28,21 L28,25 C28,26.1045695 27.1045695,27 26,27 L22,27 C20.8954305,27 20,26.1045695 20,25 L20,21 C20,19.8954305 20.8954305,19 22,19 L26,19 Z M26,19.75 L22,19.75 C21.3527913,19.75 20.8204661,20.2418747 20.7564536,20.8721948 L20.75,21 L20.75,25 C20.75,25.6472087 21.2418747,26.1795339 21.8721948,26.2435464 L22,26.25 L26,26.25 C26.6472087,26.25 27.1795339,25.7581253 27.2435464,25.1278052 L27.25,25 L27.25,21 C27.25,20.3527913 26.7581253,19.8204661 26.1278052,19.7564536 L26,19.75 Z",
  id: "Rectangle"
})));
function SvgBEappMenuIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_Icons/navigation/app_select_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBEappMenuIconWhite);
export default __webpack_public_path__ + "static/media/BEappMenu_icon_white.2c2152d37cb5677e43ddae39a4bc695c.svg";
export { ForwardRef as ReactComponent };